'use client';

import { useCallback, useEffect, useRef } from 'react';
import type { UxpRuntimeErrorPayload } from '@frameio/graphql-client/generated';
import { useDatadogLogger } from '@frameio/integrations/shared/hooks/useDatadogLogger';
import {
  useGetBufferedUxpRuntimeErrorsLazyQuery,
  useLogUxpErrorSubscription,
} from '@frameio/shared/integrations/gql';

const LOG_EVENT = 'uxp-runtime-error';

export const LogUXPErrors = () => {
  const [getBufferedUxpRuntimeErrors] = useGetBufferedUxpRuntimeErrorsLazyQuery(
    {
      context: { resolveWithUXP: true },
    }
  );
  const hasRequestedBufferedErrors = useRef(false);

  const datadogLogger = useDatadogLogger();

  const handleError = useCallback(
    (error: UxpRuntimeErrorPayload) => {
      const { message, operation, severity, source, stack, timestamp } = error;
      datadogLogger.error(LOG_EVENT, {
        error: {
          message,
          operation,
          severity,
          source,
          stack,
          timestamp,
        },
      });
    },
    [datadogLogger]
  );

  useEffect(() => {
    async function fetchData() {
      hasRequestedBufferedErrors.current = true;
      const { data } = await getBufferedUxpRuntimeErrors();
      data?.getBufferedUxpRuntimeErrors?.forEach(handleError);
    }
    if (!hasRequestedBufferedErrors.current) {
      fetchData();
    }
  }, [getBufferedUxpRuntimeErrors, handleError]);

  useLogUxpErrorSubscription({
    onData: ({ data }) => {
      if (data?.data?.uxpRuntimeError) {
        handleError(data.data.uxpRuntimeError);
      }
    },
    context: {
      resolveWithUXP: true,
    },
  });
  return null;
};
